import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface SiteLink {
  id: string;
  link_key: string;
  label: string;
  url: string;
}

let cachedLinks: Record<string, string> | null = null;
let fetchPromise: Promise<Record<string, string>> | null = null;

async function fetchLinks(): Promise<Record<string, string>> {
  const { data } = await supabase.from("site_links").select("link_key, url");
  const map: Record<string, string> = {};
  (data || []).forEach((l: any) => { map[l.link_key] = l.url; });
  cachedLinks = map;
  return map;
}

export function useSiteLinks() {
  const [links, setLinks] = useState<Record<string, string>>(cachedLinks || {});
  const [loading, setLoading] = useState(!cachedLinks);

  useEffect(() => {
    if (cachedLinks) { setLinks(cachedLinks); setLoading(false); return; }
    if (!fetchPromise) fetchPromise = fetchLinks();
    fetchPromise.then((m) => { setLinks(m); setLoading(false); });
  }, []);

  return { links, loading };
}
